import React, { useState, useEffect } from "react";
import {
  Accordion,
  Badge,
  Button,
  Col,
  Container,
  Image,
  Nav,
  Row,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useUserContext } from "../../../utils/hooks/UserContext";
import Pic from "../../../assets/images/icons/user.png";
import share from "../../../assets/images/icons/share.svg";
import pencil from "../../../assets/images/icons/pencil.svg";
import edit from "../../../assets/images/icons/edit.svg";
import banner from "../../../assets/images/coach_details_banner.png";
import following from "../../../assets/images/icons/following.svg";
import loction_grn from "../../../assets/images/icons/loction_grn.png";
import camera_grn from "../../../assets/images/icons/camera_grn.png";
import trash from "../../../assets/images/icons/trash.svg";
import plus_grn from "../../../assets/images/icons/plus_grn.png";
import Upload from "rc-upload";

import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import EditPersonalDetails from "./EditPersonalDetails";
import EditProfileAbout from "./EditProfileAbout";
import EditProfileStory from "./EditProfileStory";
import EditProfileSkills from "./EditProfileSkills";
import EditProfileTags from "./EditProfileTags";
import EditProfileBenefits from "./EditProfileBenefits";
import EditProfileClients from "./EditProfileClients";
import EditProfileSpecialties from "./EditProfileSpecialties";
import EditProfileEducation from "./EditProfileEducation";
import EditProfileExperience from "./EditProfileExperience";
import EditProfileCertificates from "./EditProfileCertificates";

import { coachImage, coachBGImage } from "../../../utils/api";
import ShareData from "../../components/ShareData";
import ShareDataComp from "../../components/ShareData";
function CoachMyProfileComponent() {
  const [EditPersonalModalShow, setEditPersonalModalShow] =
    React.useState(false);
  const [EditProfileAboutModalShow, setEditProfileAboutModalShow] =
    React.useState(false);
  const [EditProfileStoryModalShow, setEditProfileStoryModalShow] =
    React.useState(false);
  const [EditProfileSkillsModalShow, setEditProfileSkillsModalShow] =
    React.useState(false);
  const [EditProfileTagsModalShow, setEditProfileTagsModalShow] =
    React.useState(false);
  const [EditProfileBenefitsModalShow, setEditProfileBenefitsModalShow] =
    React.useState(false);
  const [EditProfileClientsModalShow, setEditProfileClientsModalShow] =
    React.useState(false);
  const [EditProfileSpecialtiesModalShow, setEditProfileSpecialtiesModalShow] =
    React.useState(false);
  const [EditProfileEducationModalShow, setEditProfileEducationModalShow] =
    React.useState(false);
  const [EditProfileExperienceModalShow, setEditProfileExperienceModalShow] =
    React.useState(false);
  const [
    EditProfileCertificatesModalShow,
    setEditProfileCertificatesModalShow,
  ] = React.useState(false);

  const { user, getUserFromToken } = useUserContext();
  const [showSocial, setShowSocial] = useState(false);
  const [img, setImage] = useState(null);

  const onChangeImage = async (selectedFile) => {
    setImage(selectedFile);
    const formData = new FormData();
    formData.append("profile_pic", selectedFile);

    try {
      // Call the API
      await coachImage(formData);
      getUserFromToken();
    } catch (error) {
      console.error(
        "Error uploading image:",
        error.response?.data || error.message
      );
      alert("Failed to upload the image. Please try again.");
    }
  };

  const onChangeImageBanner = async (selectedFile) => {
    const formData = new FormData();
    formData.append("background_img", selectedFile);

    try {
      await coachBGImage(formData);
      getUserFromToken();
    } catch (error) {
      console.error(
        "Error uploading image:",
        error.response?.data || error.message
      );
      alert("Failed to upload the image. Please try again.");
    }
  };
  useEffect(() => {
    const canonicalUrl = window.location.origin + window.location.pathname;
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);

    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);

  const formatDate = (dateString) => {
    if (!dateString || dateString == "Present" || dateString === "0000-00-00")
      return "Present"; // Handle cases where the date might be null
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      year: "numeric",
    }).format(date);
  };

  return (
    <>
      <section className="">
        <Container className="relative p-0">
          <div className="relative mb-3 overflow-hidden bg-white rounded-xl">
            {/* Banner Section */}
            <div className="relative w-full h-64 overflow-hidden bg-gray-200">
              {user?.background_img ? (
                <img
                  className="object-cover w-full h-full"
                  src={`${process.env.REACT_APP_COACH_BG_FOLDER_PATH}${user?.background_img}`}
                  alt="Banner"
                />
              ) : (
                <img
                  className="object-cover w-full h-full"
                  src={banner}
                  alt="Banner"
                />
              )}

              <div className="absolute flex top-2 right-2">
                <Upload onStart={onChangeImageBanner}>
                  <button className="p-2 transition bg-white rounded-full shadow-md hover:bg-gray-100">
                    <img className="w-5 h-5" src={camera_grn} alt="Upload" />
                  </button>
                </Upload>
              </div>
            </div>

            {/* Profile Content Section */}
            <div className="relative px-4 md:px-6">
              <div className="flex items-end justify-between">
                {/* Profile Image */}
                <div className="relative -mt-16">
                  <div className="w-32 h-32 overflow-hidden bg-gray-100 border-4 border-white rounded-full">
                    {user?.profile_pic ? (
                      <img
                        className="object-cover w-full h-full"
                        src={
                          user.login_type === "Linkedin"
                            ? user.profile_pic
                            : `${process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH}${user?.profile_pic}`
                        }
                        alt="Profile"
                      />
                    ) : (
                      <img
                        className="object-cover w-full h-full"
                        src={
                          user.login_type === "Linkedin"
                            ? user.profile_pic
                            : Pic
                        }
                        alt="Profile"
                      />
                    )}
                  </div>

                  <Upload onStart={onChangeImage}>
                    <button className="absolute bottom-0 right-0 p-2 transition bg-white rounded-full shadow-md hover:bg-gray-100">
                      <img className="w-5 h-5" src={camera_grn} alt="Upload" />
                    </button>
                  </Upload>
                </div>
              </div>

              {/* Profile Details */}
              <div className="mt-4">
                {/* Desktop View */}
                <div className="">
                  <div className="flex flex-wrap items-center justify-between pb-3">
                    <div className="w-full md:w-5/12">
                      <h4 className="text-2xl font-normal">{user?.name}</h4>
                      <div className="flex flex-wrap gap-2 mt-2">
                        {user?.tags?.map((i, index) => (
                          <span
                            key={index}
                            className="px-3 py-1 text-sm capitalize bg-gray-100 rounded-full"
                          >
                            {i}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="items-center flex-1 mt-4">
                      <div className="flex flex-wrap items-center gap-4">
                        <div className="flex rounded-xl border-[#0f5c5ba8] items-center p-2 border-2">
                          <img
                            className="w-5 h-5 mr-2"
                            src={loction_grn}
                            alt="Location"
                          />
                          <span className="font-medium text-md">
                            {[user?.state_name, user?.country_name]
                              .filter(Boolean)
                              .join(", ")}
                          </span>
                        </div>
                        <div className="flex rounded-xl border-[#0f5c5ba8] items-center p-2 border-2">
                          <img
                            className="w-5 h-5 mr-2"
                            src={following}
                            alt="Followers"
                          />
                          <span className="font-medium text-md">
                            {user?.followers_count} Followers
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="mt-4">
                      <button
                        className="flex items-center hover:bg-[#0f5c5b1c] border border-[#0f5c5b] transition-all duration-300 px-2 py-1 rounded-xl text-green-600 hover:text-green-700"
                        onClick={() => setEditPersonalModalShow(true)}
                      >
                        <i className="mr-1 bi bi-pencil"></i>
                        <span>Edit</span>
                      </button>
                    </div>

                    <div className="absolute top-4 right-6">
                      <span className="px-3 py-1 text-sm text-white bg-[#0f5c5b] rounded-xl">
                        Badge
                      </span>
                      <div className="coachpro">
                        <ShareDataComp
                          setShowSocial={setShowSocial}
                          showSocial={showSocial}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <Row className="justify-content-center">
            <Col className="col-auto">
              <div className="about_bg_img">
                {user?.profile_pic && (
                  <img
                    className="about_me_img"
                    src={
                      user.login_type == "Linkedin"
                        ? user.profile_pic
                        : `${process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH}${user?.profile_pic}`
                    }
                    alt=""
                  />
                )}
                {!user?.profile_pic && (
                  <img className="profile_img" src={Pic} alt="" />
                )}
                <Button variant="" className="uplod_camera_btn hide">
                  <img className="uplod_icn" src={camera_grn} alt="" />
                </Button>
              </div>
            </Col>
          </Row> */}
        </Container>
        <Container className="p-0">
          <Row className="g-3">
            <Col lg="8">
              <div className="gap-3 p-3 white_bg bdr-20 d-grid">
                <Row className="">
                  <Col>
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">About</h6>
                      </div>

                      {/* <NavLink to="/coach/about-yourself" className="ms-2">
                        <img height={27} src={edit} alt="" />
                      </NavLink> */}

                      <Button
                        className="pencil_edit_txt_btn"
                        onClick={() => setEditProfileAboutModalShow(true)}
                      >
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>

                    {/* <div className="mb-1 d-flex align-items-center justify-content-between">
                      <h4 className="m-0 text_brand_color1 fs-28 fw-400 font-volkhov">
                        About
                        <NavLink to="/coach/professional-details" className="ms-2">
                          <img height={27} src={edit} alt="" />
                        </NavLink>
                      </h4>
                      <Button size="sm" variant="" className="p-0 hide">
                        <img height={27} src={plus_grn} alt="" />
                      </Button>
                    </div> */}
                    <div className="">
                      <h4 className="mb-3 fs-20 fw-600 text_brand_color1">
                        My Introduction
                      </h4>
                      {user?.about ? (
                        <p
                          className="text-justify fs-16 fw-400"
                          dangerouslySetInnerHTML={{ __html: user?.about }}
                        />
                      ) : (
                        <div className="my-2 text-center">
                          <p className="m-0 fs-14">Data not found</p>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="">
                  <Col>
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">My Story</h6>
                      </div>

                      <Button
                        className="pencil_edit_txt_btn"
                        onClick={() => setEditProfileStoryModalShow(true)}
                      >
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>
                    {/* <div className="mb-1 d-flex align-items-center justify-content-between">
                      <h4 className="m-0 text_brand_color1 fs-28 fw-400 font-volkhov">
                        My Story
                        <NavLink to="/coach/professional-details" className="ms-2">
                          <img height={27} src={edit} alt="" />
                        </NavLink>
                      </h4>
                      <Button size="sm" variant="" className="p-0 hide">
                        <img height={27} src={plus_grn} alt="" />
                      </Button>
                    </div> */}
                    <div>
                      <h4 className="mb-3 fs-20 fw-600 text_brand_color1">
                        Reflections on My Life
                      </h4>

                      {user?.story ? (
                        <p
                          className="text-justify fs-16 fw-400"
                          dangerouslySetInnerHTML={{ __html: user?.story }}
                        />
                      ) : (
                        <div className="my-2 text-center">
                          <p className="m-0 fs-14">Data not found</p>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="">
                  <Col className="mx-auto col-12">
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">Tags</h6>
                      </div>

                      <Button
                        className="pencil_edit_txt_btn"
                        onClick={() => setEditProfileTagsModalShow(true)}
                      >
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>
                    {/* <div className="mb-1 d-flex align-items-center justify-content-between">
                      <h4 className="m-0 text_brand_color1 fs-28 fw-400 font-volkhov">
                        Tags
                        <NavLink to="/coach/coaching-details" className="ms-2">
                          <img height={27} src={edit} alt="" />
                        </NavLink>
                      </h4>
                      <Button size="sm" variant="" className="p-0 hide">
                        <img height={27} src={edit} alt="" />
                      </Button>
                    </div> */}
                    <div>
                      <h4 className="mb-3 fs-20 fw-600 text_brand_color1">
                        My
                      </h4>
                    </div>
                    <div className="mb-1 d-flex align-items-center">
                      {user?.tags && user?.tags.length > 0 ? (
                        user?.tags?.map((i) => {
                          return (
                            <div>
                              <p className="px-1 m-0 fs-14 fw-400 text_brand_color4 capitalize-label">
                                #{i}
                              </p>
                            </div>
                          );
                        })
                      ) : (
                        <div className="my-2 text-center">
                          <p className="m-0 fs-14">Data not found</p>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg="4">
              <div className="gap-3 p-3 white_bg bdr-20 d-grid">
                <Row className="">
                  <Col className="mx-auto col-12">
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">Education</h6>
                      </div>

                      <Button
                        className="pencil_edit_txt_btn"
                        onClick={() => setEditProfileEducationModalShow(true)}
                      >
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>

                    <hr className="mt-2" />

                    {/* <div className="mb-1 d-flex align-items-center justify-content-between">
                      <h4 className="m-0 text_brand_color1 fs-28 fw-400 font-volkhov">
                        Education
                        <NavLink to="/coach/professional-details" className="ms-2">
                          <img height={27} src={edit} alt="" />
                        </NavLink>
                      </h4>
                      <Button size="sm" variant="" className="p-0 hide">
                        <img height={27} src={plus_grn} alt="" />
                      </Button>
                    </div> */}
                    <div>
                      {user?.educations && user?.educations.length > 0 ? (
                        user?.educations?.map((i) => {
                          return (
                            <div className="mb-1 d-flex align-items-center justify-content-between">
                              <div>
                                <p className="m-0 fs-18 fw-400 text_brand_color4">
                                  {i?.course}
                                </p>
                                <small className="d-block fs-14 fw-400 text_brand_color4">
                                  {i?.university_colleage}
                                </small>
                              </div>
                              <Nav className="">
                                <Nav.Item>
                                  <Button variant="" className="p-1 hide">
                                    <Image height={15} src={trash} alt="" />
                                  </Button>
                                </Nav.Item>
                                <Nav.Item>
                                  <Button variant="" className="p-1 hide">
                                    <img height={27} src={edit} alt="" />
                                  </Button>
                                </Nav.Item>
                              </Nav>
                            </div>
                          );
                        })
                      ) : (
                        <div className="my-2 text-center">
                          <p className="m-0 fs-14">Data not found</p>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="">
                  <Col className="mx-auto col-12">
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">Experience</h6>
                      </div>

                      <Button
                        className="pencil_edit_txt_btn"
                        onClick={() => setEditProfileExperienceModalShow(true)}
                      >
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>
                    <hr className="mt-2" />

                    {/* <div className="mb-1 d-flex align-items-center justify-content-between">
                      <h4 className="m-0 text_brand_color1 fs-28 fw-400 font-volkhov">
                        Experience
                        <NavLink to="/coach/professional-details" className="ms-2">
                          <img height={27} src={edit} alt="" />
                        </NavLink>
                      </h4>
                      <Button size="sm" variant="" className="p-0 hide">
                        <img height={25} src={plus_grn} alt="" />
                      </Button>
                    </div> */}
                    <div>
                      {user?.experiences && user?.experiences.length > 0 ? (
                        user?.experiences?.map((i) => {
                          return (
                            <div className="mb-1 d-flex align-items-center justify-content-between">
                              <div>
                                <p className="m-0 fs-18 fw-400 text_brand_color4">
                                  {i?.title}
                                </p>
                                <small className="d-block fs-14 fw-400 text_brand_color4">
                                  {i?.company_name}
                                </small>
                                <small className="d-block fs-14 fw-400 text_brand_color4">
                                  {/*{i?.start_date} - {i?.end_date}*/}
                                  {formatDate(i?.start_date)} -{" "}
                                  {formatDate(i?.end_date)}
                                </small>
                              </div>
                              <Nav className="">
                                <Nav.Item>
                                  <Button variant="" className="p-1 hide">
                                    <Image height={15} src={trash} alt="" />
                                  </Button>
                                </Nav.Item>
                                <Nav.Item>
                                  <Button variant="" className="p-1 hide">
                                    <img height={27} src={edit} alt="" />
                                  </Button>
                                </Nav.Item>
                              </Nav>
                            </div>
                          );
                        })
                      ) : (
                        <div className="my-2 text-center">
                          <p className="m-0 fs-14">Data not found</p>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="">
                  <Col className="mx-auto col-12">
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">Certificates</h6>
                      </div>

                      <Button
                        className="pencil_edit_txt_btn"
                        onClick={() =>
                          setEditProfileCertificatesModalShow(true)
                        }
                      >
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>

                    {/* <div className="mb-1 d-flex align-items-center justify-content-between">
                      <h4 className="m-0 text_brand_color1 fs-28 fw-400 font-volkhov">
                        Certificates
                        <NavLink to="/coach/professional-details" className="ms-2">
                          <img height={27} src={edit} alt="" />
                        </NavLink>
                      </h4>
                      <Button size="sm" variant="" className="p-0 hide">
                        <img height={25} src={plus_grn} alt="" />
                      </Button>
                    </div> */}

                    <hr className="mt-2" />

                    <div>
                      {user?.certificates && user?.certificates.length > 0 ? (
                        user?.certificates?.map((i) => {
                          return (
                            <div className="mb-1 d-flex align-items-center justify-content-between">
                              <div>
                                <p className="m-0 fs-18 fw-400 text_brand_color4">
                                  <u className="text-decoration-none">
                                    {i?.name}
                                  </u>
                                </p>
                                <small className="d-block fs-14 fw-400 text_brand_color4">
                                  {i?.organization}
                                </small>
                              </div>
                              <Nav className="">
                                <Nav.Item>
                                  <Button variant="" className="p-1 hide">
                                    <Image height={15} src={trash} alt="" />
                                  </Button>
                                </Nav.Item>
                                <Nav.Item>
                                  <Button variant="" className="p-1 hide">
                                    <img height={27} src={edit} alt="" />
                                  </Button>
                                </Nav.Item>
                              </Nav>
                            </div>
                          );
                        })
                      ) : (
                        <div className="my-2 text-center">
                          <p className="m-0 fs-14">Data not found</p>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col lg="12">
              <div className="gap-3 p-3 white_bg bdr-20 d-grid">
                <Row className="">
                  <Col className="mx-auto col-12">
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">Skills</h6>
                      </div>

                      <Button
                        className="pencil_edit_txt_btn"
                        onClick={() => setEditProfileSkillsModalShow(true)}
                      >
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>
                    {/* <div className="mb-1 d-flex align-items-center justify-content-between">
                      <h4 className="m-0 text_brand_color1 fs-28 fw-400 font-volkhov">
                        Skills
                        <NavLink to="/coach/coaching-details" className="ms-2">
                          <img height={27} src={edit} alt="" />
                        </NavLink>
                      </h4>
                      <Button size="sm" variant="" className="p-0 hide">
                        <img height={25} src={plus_grn} alt="" />
                      </Button>
                    </div> */}
                    <div>
                      <h4 className="mb-3 fs-20 fw-600 text_brand_color1">
                        Area of my Expertise{" "}
                      </h4>
                      <Nav>
                        {user?.skills && user?.skills.length > 0 ? (
                          user?.skills?.map((i) => {
                            return (
                              <Nav.Item className="mb-2 me-2">
                                <Button
                                  variant="added_language"
                                  className="h-100 fs-14"
                                >
                                  {i?.name}
                                </Button>
                              </Nav.Item>
                            );
                          })
                        ) : (
                          <div className="my-2 text-center">
                            <p className="m-0 fs-14">Data not found</p>
                          </div>
                        )}
                      </Nav>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg="12">
              <div className="gap-3 p-3 white_bg bdr-20 d-grid">
                <Row className="">
                  <Col className="mx-auto col-12">
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">Specialities</h6>
                      </div>

                      <Button
                        className="pencil_edit_txt_btn"
                        onClick={() => setEditProfileSpecialtiesModalShow(true)}
                      >
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>
                    {/* <div className="mb-1 d-flex align-items-center justify-content-between">
                      <h4 className="m-0 text_brand_color1 fs-28 fw-400 font-volkhov">
                        Specialties
                        <NavLink to="/coach/about-yourself" className="ms-2">
                          <img height={27} src={edit} alt="" />
                        </NavLink>
                      </h4>
                      <Button size="sm" variant="" className="p-0 hide">
                        <img height={25} src={plus_grn} alt="" />
                      </Button>
                    </div> */}
                    <div>
                      <h4 className="mb-3 fs-20 fw-600 text_brand_color1">
                        What you can expect from me ?
                      </h4>
                      <Accordion defaultActiveKey={["0"]} alwaysOpen>
                        <ul className="px-3">
                          {user?.specialties && user?.specialties.length > 0 ? (
                            JSON.parse(user?.specialties)?.map((i, index) => {
                              return (
                                <div>
                                  <li>
                                    <Accordion.Item eventKey="0">
                                      <Accordion.Header>
                                        {i?.speciality}
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        <p className="fs-14">
                                          {i?.description}
                                        </p>
                                      </Accordion.Body>
                                    </Accordion.Item>
                                  </li>
                                </div>
                              );
                            })
                          ) : (
                            <div className="my-2 text-center">
                              <p className="m-0 fs-14">Data not found</p>
                            </div>
                          )}
                        </ul>
                      </Accordion>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg="12">
              <div className="gap-3 p-3 white_bg bdr-20 d-grid">
                <Row className="hr_vertical gx-5">
                  <Col md="6" className="mt-4">
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">Benefits</h6>
                      </div>

                      <Button
                        className="pencil_edit_txt_btn"
                        onClick={() => setEditProfileBenefitsModalShow(true)}
                      >
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>
                    {/* <div className="d-flex align-items-end justify-content-between">
                      <h4 className="text_brand_color1 fs-28 fw-400 font-volkhov">
                        Benefits
                        <NavLink to="/coach/coaching-details" className="ms-2">
                          <img height={27} src={edit} alt="" />
                        </NavLink>
                      </h4>
                      <Button variant="" className="hide">
                        <img height={27} src={edit} alt="" />
                      </Button>
                    </div> */}
                    <div>
                      <h4 className="mb-3 fs-20 fw-600 text_brand_color1">
                        Why choose me
                      </h4>
                      {user?.benefits && user?.benefits.length > 0 ? (
                        user?.benefits?.map((i) => {
                          return (
                            <ul className="flex items-center gap-2 transition-all duration-150 bc_list_flex hover:scale-105">
                              <img src="/bc_icon.png" alt="" /> <li>{i}</li>
                            </ul>
                          );
                        })
                      ) : (
                        <div className="my-2 text-center">
                          <p className="m-0 fs-14">Data not found</p>
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md="6" className="mt-4">
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">Clients</h6>
                      </div>

                      <Button
                        className="pencil_edit_txt_btn"
                        onClick={() => setEditProfileClientsModalShow(true)}
                      >
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>
                    {/* <div className="d-flex align-items-end justify-content-between">
                      <h4 className="text_brand_color1 fs-28 fw-400 font-volkhov">
                        Clients
                        <NavLink to="/coach/coaching-details" className="ms-2">
                          <img height={27} src={edit} alt="" />
                        </NavLink>
                      </h4>
                      <Button variant="" className="hide">
                        <img height={27} src={edit} alt="" />
                      </Button>
                    </div> */}
                    <div>
                      <h4 className="mb-3 fs-20 fw-600 text_brand_color1">
                        Whom I can help
                      </h4>
                      {user?.professions && user?.professions.length > 0 ? (
                        user?.professions?.map((i) => {
                          return (
                            <ul className="flex items-center gap-2 transition-all duration-150 bc_list_flex hover:scale-105">
                              <img src="/bc_icon.png" alt="" /> <li>{i}</li>
                            </ul>
                          );
                        })
                      ) : (
                        <div className="my-2 text-center">
                          <p className="m-0 fs-14">Data not found</p>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg="12">
              <div className="">
                {/* <Row className="">
                  <Col className="mx-auto col-12">
                    <div className="d-flex align-items-end justify-content-between">
                      <div className="text-center hdng_a">
                        <h6 className="text-uppercase">Pricing</h6>
                      </div>
                      
                      <Button className="pencil_edit_txt_btn">
                        <i className="bi bi-pencil"></i>
                        <span>Edit</span>
                      </Button>
                    </div>
                    <div>
                      <h4 className="mb-3 fs-20 fw-600 text_brand_color1">My</h4>
                      {
                        user?.programs && user?.programs.length > 0 ?
                          user?.programs?.map((i) => {
                            return (
                              <div className="mb-1 d-flex align-items-center justify-content-between">
                                <div>
                                  <h4 className="m-0 fs-24 fw-700 text_brand_color2">
                                    ${i?.price}
                                  </h4>
                                  <p className="m-0 fs-20 fw-500 text_brand_color7">
                                    {i?.session_title}
                                  </p>
                                  <p className="fs-14 fw-400 text_brand_color4">
                                    {i?.no_of_session} Live meeting on online platform for{" "}
                                    {i?.duration} days
                                  </p>
                                </div>
                                <Nav className="">
                                  <Nav.Item>
                                    <Button variant="" className="p-1 hide">
                                      <Image height={15} src={trash} alt="" />
                                    </Button>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Button variant="" className="p-1 hide">
                                      <img height={27} src={edit} alt="" />
                                    </Button>
                                  </Nav.Item>
                                </Nav>
                              </div>
                            );
                          })
                          :
                          <div className="my-2 text-center">
                            <p className="m-0 fs-14">Data not found</p>
                          </div>
                      }
                    </div>
                  </Col>
                </Row> */}
              </div>
            </Col>
            <Col lg="12">
              <div className="">
                <Row className="">
                  <Col className="mx-auto col-12">
                    <div>
                      <h4 className="mb-3 fs-20 fw-600 text_brand_color1">
                        {user?.testimonials?.length > 0
                          ? "Testimonial"
                          : "Users say about Qoach"}
                      </h4>
                    </div>

                    <ol>
                      {user?.testimonials && user?.testimonials.length > 0 ? (
                        user?.testimonials?.map((i) => {
                          return (
                            <li>
                              <Row className="ps-2.5">
                                <Col md="8">
                                  <p className="fs-16 fw-400">
                                    {i?.description}
                                  </p>
                                </Col>
                                <Col md="4">
                                  <div className="d-flex align-items-center">
                                    <img
                                      width="60"
                                      height="60"
                                      class="rounded-circle"
                                      src={
                                        process.env
                                          .REACT_APP_COACH_TESTIMONIAL_PATH +
                                        i.image
                                      }
                                      alt=""
                                    />
                                    <p className="m-0 text_brand_color7 fs-20 fw-700 ms-2">
                                      {i?.name}, {i?.company_name}
                                    </p>
                                  </div>
                                </Col>
                              </Row>
                            </li>
                          );
                        })
                      ) : user?.adminTestimonials &&
                        user?.adminTestimonials.length > 0 ? (
                        user?.adminTestimonials?.map((i) => {
                          return (
                            <li>
                              <Row className="ps-2.5">
                                <Col md="8">
                                  <p className="fs-16 fw-400">
                                    {i?.description}
                                  </p>
                                </Col>
                                <Col md="4">
                                  <div className="d-flex align-items-center">
                                    <img
                                      width="60"
                                      height="60"
                                      class="rounded-circle"
                                      src={i.image}
                                      alt=""
                                    />
                                    <div className="d-flex flex-column">
                                      <p className="m-0 text_brand_color7 fs-20 fw-700 ms-2">
                                        {i?.author}
                                      </p>
                                      <p>
                                        <small className="m-0 text_brand_color7 ms-2">
                                          {i?.designation}
                                        </small>
                                      </p>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </li>
                          );
                        })
                      ) : (
                        <div className="my-2 text-center">
                          <p className="m-0 fs-14">Data not found</p>
                        </div>
                      )}
                    </ol>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <EditPersonalDetails
        show={EditPersonalModalShow}
        onHide={() => setEditPersonalModalShow(false)}
      />

      <EditProfileAbout
        show={EditProfileAboutModalShow}
        onHide={() => setEditProfileAboutModalShow(false)}
      />
      <EditProfileStory
        show={EditProfileStoryModalShow}
        onHide={() => setEditProfileStoryModalShow(false)}
      />
      <EditProfileSkills
        show={EditProfileSkillsModalShow}
        onHide={() => setEditProfileSkillsModalShow(false)}
      />

      <EditProfileTags
        show={EditProfileTagsModalShow}
        onHide={() => setEditProfileTagsModalShow(false)}
      />

      <EditProfileBenefits
        show={EditProfileBenefitsModalShow}
        onHide={() => setEditProfileBenefitsModalShow(false)}
      />

      <EditProfileClients
        show={EditProfileClientsModalShow}
        onHide={() => setEditProfileClientsModalShow(false)}
      />

      <EditProfileSpecialties
        show={EditProfileSpecialtiesModalShow}
        onHide={() => setEditProfileSpecialtiesModalShow(false)}
      />

      <EditProfileEducation
        show={EditProfileEducationModalShow}
        onHide={() => setEditProfileEducationModalShow(false)}
      />

      <EditProfileExperience
        show={EditProfileExperienceModalShow}
        onHide={() => setEditProfileExperienceModalShow(false)}
      />

      <EditProfileCertificates
        show={EditProfileCertificatesModalShow}
        onHide={() => setEditProfileCertificatesModalShow(false)}
      />
    </>
  );
}

export default CoachMyProfileComponent;
